import moment from 'moment';


const formatDate = (date) => {
    const rawDate = date.split('-');

    return `${rawDate[2]}.${rawDate[1]}.${rawDate[0]}`;
}

const showHolidays = (date) => {
  const now = moment();

  const holidayStartFragments = date.from.split('-');
  const holidayStartMomentObj = moment(`${holidayStartFragments[0]}-${holidayStartFragments[1]}-${holidayStartFragments[2]}`);

  const holidayEndFragments = date.till.split('-');
  const holidayEndMomentObj = moment(`${holidayEndFragments[0]}-${holidayEndFragments[1]}-${holidayEndFragments[2]}`);

  const daysTillHolidays = holidayStartMomentObj.diff(now, 'days');
  const daysTillHolidaysEnd = holidayEndMomentObj.diff(now, 'days');

  if (daysTillHolidays <= 14 && daysTillHolidaysEnd >= 0) {
    return true;
  } else {
    return false;
  }
};

export {
    formatDate,
    showHolidays
};
